import React, { useRef } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';

import { limitString } from "../../../helpers/format";
import Link from "../../../components/Link";
import Title from "../../../components/Title";
import Slider from "../../../components/Slider";
import Editor from "../../../components/Editor";
import Section from "../../../components/Section";
import Background from "../../../components/Background";

import style from "./style.module.css";

export default function BookBanner({ books = [], autoplay = false, delay = 5000 }) {

	const swiperRef = useRef(null);

	let modules = [Pagination];
	if (autoplay === true) {
		modules.push(Autoplay);
	}

	return (
		<>
			{
				(books || []).length > 0 && (
					<Slider className="bookBannerSlider" swiperRef={swiperRef} autoplay={autoplay}>
						<Swiper
							ref={swiperRef}
							modules={modules}
							autoplay={{
								delay: delay,
								disableOnInteraction: false,
								pauseOnMouseEnter: true,
							}}
							spaceBetween={0}
							slidesPerView={1}
							pagination={{
								clickable: true,
								bulletClass: style.swiperPaginationBullet,
								bulletActiveClass: style.swiperPaginationBulletActive,
								el: `.${style.swiperPagination}`,
							}}
						>
							{
								books.length > 0 && books.map((item, index) => {
									return (
										<SwiperSlide key={`book_sliderItem_${index}`} className={style.sliderItem}>
											<div className={style.slider}>
												<Link className={style.fullBlock} to={`/book/${item.url}`}></Link>
												<Background src={item.thumbnail_image} size="2560x1440" cPosition="topLeft" />
												<Section className={`${style.articleBanner} ${style.sectionRow}`}>
													<div className={`${style.sectionTextContent} ${style.col2}`}>
														{
															item.sub_name !== "" && (
																<Title
																	tag="h6"
																	className="fontTeko"
																	transform="uppercase"
																>
																	{item.sub_name}
																</Title>
															)
														}
														{
															item.name !== "" && (
																<Title className="bigTitle">{item.name}</Title>
															)
														}
														{
															item.description !== "" && (
																<div className={style.description}>
																	<Editor text={limitString(item.description, 20, true)} />
																</div>
															)
														}
													</div>
													{
														item.preview_image !== "" && (
															<div className={`${style.imageContent} ${style.col2}`}>
																<div className={style.imageWrap}></div>
																<Background src={item.preview_image} size="2560x1440" cPosition="topRight" />
															</div>
														)
													}
												</Section>
											</div>
										</SwiperSlide>
									)
								})
							}
							<div className={style.swiperPagination}></div>
						</Swiper>
					</Slider>
				)
			}
		</>
	)
}